/*
 * @Author: niyingfeng
 * @Date: 2022-03-02 20:51:17
 * @LastEditors: niyingfeng
 * @LastEditTime: 2022-03-03 21:54:05
 * @FilePath: /cheese/web/src/public/filters/linkAdapt.js
 * @Description: 由于配置下发的均为h5地址，进行兼容处理(当前默认为PC)。以及透传 csource在此处理。
 * 
 */

import Vue from 'vue'
import { searchStringToParams, searchParamsToString, appendLinkWithCsource } from '../js/convert'
import { replaceHostPrefix } from '../js/utils'

Vue.filter('hostAdapt', replaceHostPrefix)
Vue.filter('playLinkAdapt', link => {
    return link.replace('m.bilibili.com', 'www.bilibili.com')
})
Vue.filter('csourceTransmit', appendLinkWithCsource) 